import React, { useContext } from "react";
import {  Route, Switch } from "react-router-dom";
import Error404 from "../404";
import { useTranslations } from "../hooks/use-translations";
import { HelpContent } from "./help-content";
import { ContactInfo } from "./contact-info";
import { store } from "../components/Store";
import { useLanguage } from "../hooks/use-language";
import { useId } from "../hooks/use-id";

/**
 * componente principal de ayuda. Su principal función es establecer las rutas de las diferentes secciones de ayuda
 * @returns {JSX.Element} Ayuda
 */
export const Ayuda = () => {
    const globalState = useContext(store);
    const { state } = globalState;
    const isLogged = state.sesionActiva !== null && state.sesionActiva === "SI";

    return (
        <>
            <Switch>
                <Route exact path="/ayuda" component={MainSection} />
                <Route exact path="/ayuda/libros" component={MainSection} />
                <Route exact path="/ayuda/plataforma" component={MainSection} />
                <Route exact path="/ayuda/descarga" component={MainSection} />
                <Route exact path="/ayuda/apps" component={MainSection} />
                {isLogged && <Route exact path="/ayuda/perfil" component={MainSection} />}
                <Route component={Error404} />
            </Switch>
        </>
    )
}

/**
 * Componente que muestra la sección principal de ayuda.
 */
const MainSection = () => {
    const lang = useLanguage();
    const helpTexts = useTranslations({ section: "ayuda", lang: lang });

    const contactTitle= useId('contact-title');
    const helpContentTitle= useId('help-content-title');
    return (
        <>
            <div className="main-container py-5">
                <div className="container secciones-ayuda">
                    <h1 className="mb-3">{helpTexts?.instrucciones?.titulo || 'Ayuda'}</h1>
                    <div className="main-content">
                        <div className="row">
                            <aside aria-labelledby={contactTitle} className="col-lg-5 mb-3 mb-lg-0 p-0 order-lg-2" >
                                <h2 id={contactTitle}className="sr-only">
                                    {helpTexts?.accesibilidad?.cont_ayuda || 'Información de contacto'}
                                </h2>
                                <ContactInfo textsDescarga={helpTexts?.datos_contacto} />
                            </aside>
                            <section aria-labelledby={helpContentTitle} className="col-lg-7 px-0 py-3 p-sm-3 order-lg-1">
                                <h2 id={helpContentTitle} className="sr-only">
                                    {helpTexts?.accesibilidad?.info_contacto || 'Contenido de ayuda'}
                                </h2>
                                <HelpContent helpTexts={helpTexts} />
                            </section>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Ayuda;